function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import PropTypes from 'prop-types';
import { AutoSizer } from 'react-virtualized';
import noop from 'lodash/noop';
import isEmpty from 'lodash/isEmpty';
import EmptyState from '@adsk/nirvana-empty-state';
import { withT } from '@adsk/nirvana-locale';
import locales from './locales';
import * as TreeHelper from './treeHelper';
import TreeNode from './TreeNode';
import { StyledList } from './styles';

/**
 * VirtualizedTree.
 * Built based on react-virtualized List.
 * https://github.com/bvaughn/react-virtualized/blob/master/docs/List.md
 */
export var VirtualizedTree = /*#__PURE__*/function (_React$Component) {
  function VirtualizedTree(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      selectedKeys: TreeHelper.cloneArray(props.selectedKeys !== undefined ? props.selectedKeys : props.defaultSelectedKeys),
      expandedKeys: TreeHelper.cloneArray(props.expandedKeys !== undefined ? props.expandedKeys : props.defaultExpandedKeys),
      isMultiple: props.multiple || Array.isArray(props.defaultSelectedKeys) && props.defaultSelectedKeys.length > 1,
      innerState: {},
      flatNodes: []
    };

    // Save the last selected key for shift selection under multiple mode.
    _this._lastSelectedKey = null;
    _this.rowRenderer = _this.rowRenderer.bind(_this);
    _this.rowHeight = _this.rowHeight.bind(_this);
    _this.handleLoadNode = _this.handleLoadNode.bind(_this);
    _this.handleSelectNode = _this.handleSelectNode.bind(_this);
    _this.handleToggleNode = _this.handleToggleNode.bind(_this);
    return _this;
  }
  _inheritsLoose(VirtualizedTree, _React$Component);
  var _proto = VirtualizedTree.prototype;
  _proto.generateFlatNodes = function generateFlatNodes(expandedKeys, innerState, nodes) {
    var _this$props = this.props,
      valueKey = _this$props.valueKey,
      childrenKey = _this$props.childrenKey,
      onDuplicatedKeys = _this$props.onDuplicatedKeys;
    var _TreeHelper$genFlatNo = TreeHelper.genFlatNodes({
        nodes: nodes,
        valueKey: valueKey,
        childrenKey: childrenKey,
        expandedKeys: expandedKeys,
        innerState: innerState
      }),
      flatNodes = _TreeHelper$genFlatNo.flatNodes,
      duplicatedKeys = _TreeHelper$genFlatNo.duplicatedKeys;
    onDuplicatedKeys({
      keys: duplicatedKeys,
      nodes: flatNodes
    });
    return flatNodes;
  };
  _proto.componentDidMount = function componentDidMount() {
    var _this$state = this.state,
      expandedKeys = _this$state.expandedKeys,
      innerState = _this$state.innerState;
    var nodes = this.props.nodes;
    this.setState({
      flatNodes: this.generateFlatNodes(expandedKeys, innerState, nodes)
    });
  };
  _proto.componentDidUpdate = function componentDidUpdate(preProps, preState) {
    var _this2 = this;
    var _this$props2 = this.props,
      expandedKeys = _this$props2.expandedKeys,
      selectedKeys = _this$props2.selectedKeys,
      nodes = _this$props2.nodes;
    var innerState = this.state.innerState;
    var newState = {};
    if (expandedKeys !== undefined && expandedKeys !== preProps.expandedKeys) {
      newState.expandedKeys = expandedKeys;
    }
    if (selectedKeys !== undefined && selectedKeys !== preProps.selectedKeys) {
      newState.selectedKeys = selectedKeys;
    }
    if (nodes !== preProps.nodes || innerState !== preState.innerState || (newState.expandedKeys || this.state.expandedKeys) !== preState.expandedKeys || (newState.selectedKeys || this.state.selectedKeys) !== preState.selectedKeys) {
      newState.flatNodes = this.generateFlatNodes(newState.expandedKeys || this.state.expandedKeys, innerState, nodes);
    }
    if (!isEmpty(newState)) {
      this.setState(newState, function () {
        return _this2.maybeMeasureAllRows();
      });
    }
  };
  _proto.getExpandedKeys = function getExpandedKeys() {
    return TreeHelper.cloneArray(this.state.expandedKeys);
  };
  _proto.setExpandedKeys = function setExpandedKeys(expandedKeys) {
    if (this.props.expandedKeys !== undefined) return;
    this.setState({
      expandedKeys: TreeHelper.cloneArray(expandedKeys)
    });
  };
  _proto.getSelectedKeys = function getSelectedKeys() {
    return TreeHelper.cloneArray(this.state.selectedKeys);
  };
  _proto.setSelectedKeys = function setSelectedKeys(selectedKeys) {
    if (this.props.selectedKeys !== undefined) return;
    this.setState({
      selectedKeys: TreeHelper.cloneArray(selectedKeys)
    });
  };
  _proto.getFlatNodes = function getFlatNodes() {
    return TreeHelper.cloneArray(this.state.flatNodes);
  };
  _proto.scrollToNode = function scrollToNode(node) {
    if (node === void 0) {
      node = {};
    }
    var valueKey = this.props.valueKey;
    var flatNodes = this.state.flatNodes;
    var index = flatNodes.findIndex(function (flat) {
      return flat[valueKey] === node[valueKey];
    });
    if (index !== -1 && this.treeListRef) {
      this.treeListRef.scrollToRow(index);
    }
  };
  _proto.forceUpdate = function forceUpdate() {
    if (this.treeListRef) this.treeListRef.forceUpdateGrid();
  };
  _proto.maybeMeasureAllRows = function maybeMeasureAllRows() {
    // Only retry to update if rowHeight is a function (dynamic row height)
    if (typeof this.props.rowHeight !== 'function' || !this.treeListRef) return;
    this.treeListRef.recomputeRowHeights();
  };
  _proto.handleLoadNode = function handleLoadNode(node) {
    var _nodeKey,
      _objectSpread2,
      _this3 = this;
    var _this$props3 = this.props,
      valueKey = _this$props3.valueKey,
      onExpandNode = _this$props3.onExpandNode;
    var expandedKeys = this.state.expandedKeys;
    var nodeKey = node[valueKey];
    this.setState({
      expandedKeys: [].concat(expandedKeys, [nodeKey])
    });
    var result = onExpandNode && onExpandNode(node);
    if (!(result instanceof Promise)) {
      return Promise.resolve();
    }
    this.setState({
      innerState: _objectSpread(_objectSpread({}, this.state.innerState), {}, (_objectSpread2 = {}, _objectSpread2[nodeKey] = (_nodeKey = {}, _nodeKey[TreeHelper.NODE_KEYS.NODE_ACTION_TYPE] = TreeHelper.NODE_KEYS.NODE_LOADER_KEY, _nodeKey.parentNode = node, _nodeKey), _objectSpread2))
    });
    return result.then(function () {
      var innerState = _objectSpread({}, _this3.state.innerState);
      delete innerState[nodeKey];
      _this3.setState({
        innerState: innerState
      });
    })["catch"](function () {
      var _nodeKey2, _objectSpread3;
      _this3.setState({
        innerState: _objectSpread(_objectSpread({}, _this3.state.innerState), {}, (_objectSpread3 = {}, _objectSpread3[nodeKey] = (_nodeKey2 = {}, _nodeKey2[TreeHelper.NODE_KEYS.NODE_ACTION_TYPE] = TreeHelper.NODE_KEYS.NODE_ERROR_KEY, _nodeKey2.parentNode = node, _nodeKey2), _objectSpread3))
      });
    });
  };
  _proto.handleExpandNode = function handleExpandNode(node) {
    var valueKey = this.props.valueKey;
    var expandedKeys = this.state.expandedKeys;
    if (expandedKeys.includes(node[valueKey])) return Promise.resolve();
    return this.handleLoadNode(node);
  };
  _proto.handleToggleNode = function handleToggleNode(node) {
    var _this$props4 = this.props,
      valueKey = _this$props4.valueKey,
      onUnexpandNode = _this$props4.onUnexpandNode;
    var expandedKeys = this.state.expandedKeys;
    var nodeKey = node[valueKey];
    if (expandedKeys.includes(nodeKey)) {
      this.setState({
        expandedKeys: expandedKeys.filter(function (key) {
          return key !== nodeKey;
        })
      });
      onUnexpandNode && onUnexpandNode(node);
    } else {
      this.handleExpandNode(node);
    }
  };
  _proto.handleSelectNode = function handleSelectNode(node, event) {
    var _this$state2 = this.state,
      isMultiple = _this$state2.isMultiple,
      selectedKeys = _this$state2.selectedKeys,
      flatNodes = _this$state2.flatNodes;
    var _this$props5 = this.props,
      valueKey = _this$props5.valueKey,
      isNodeDisabled = _this$props5.isNodeDisabled,
      isNodeSelectable = _this$props5.isNodeSelectable,
      enableShiftSelection = _this$props5.enableShiftSelection,
      enableCrossParentSelection = _this$props5.enableCrossParentSelection;
    var nodeKey = node[valueKey];
    var updatedKeys = [nodeKey];

    // Handle multiple selection
    if (isMultiple) {
      var _event$nativeEvent;
      var lastSelectedKey = this._lastSelectedKey;
      this._lastSelectedKey = nodeKey;
      var targetSelectKeys = [nodeKey];
      if (enableShiftSelection && (event === null || event === void 0 ? void 0 : (_event$nativeEvent = event.nativeEvent) === null || _event$nativeEvent === void 0 ? void 0 : _event$nativeEvent.shiftKey) === true) {
        var _document, _document$getSelectio;
        // Clear document selection when shift key is pressed.
        (_document = document) === null || _document === void 0 ? void 0 : (_document$getSelectio = _document.getSelection()) === null || _document$getSelectio === void 0 ? void 0 : _document$getSelectio.removeAllRanges();

        // Pick selectable keys in range based on current & previous selected key.
        if (lastSelectedKey !== null && lastSelectedKey !== nodeKey) {
          targetSelectKeys = TreeHelper.getSelectableKeys({
            flatNodes: flatNodes,
            valueKey: valueKey,
            preNodeKey: lastSelectedKey,
            curNodeKey: nodeKey,
            allowCrossParent: enableCrossParentSelection,
            isNodeDisabled: isNodeDisabled,
            isNodeSelectable: isNodeSelectable
          });
        }
      }

      // Reset updatedKeys by mutate current selectedKeys based on targetSelectKeys
      updatedKeys = [].concat(selectedKeys);
      // Decide the batch selection behavior based on current node status.
      var isToSelect = !selectedKeys.includes(nodeKey);
      targetSelectKeys.forEach(function (key) {
        if (isToSelect) {
          if (!updatedKeys.includes(key)) updatedKeys.push(key);
        } else {
          var idx = updatedKeys.indexOf(key);
          if (idx !== -1) updatedKeys.splice(idx, 1);
        }
      });
    }
    this.setState({
      selectedKeys: updatedKeys
    });
    this.props.onSelectNodesChange(updatedKeys, event);
  };
  _proto.isNodeExpandable = function isNodeExpandable(node) {
    var _this$props6 = this.props,
      isNodeExpandable = _this$props6.isNodeExpandable,
      childrenKey = _this$props6.childrenKey;
    if (isNodeExpandable) return isNodeExpandable(node);
    return TreeHelper.hasChildren(node[childrenKey]);
  };
  _proto.rowHeight = function rowHeight(_ref) {
    var index = _ref.index;
    var rowHeight = this.props.rowHeight;
    if (typeof rowHeight !== 'function') return rowHeight;
    var node = this.state.flatNodes[index];
    return rowHeight({
      index: index,
      node: node
    });
  };
  _proto.rowRenderer = function rowRenderer(_ref2) {
    var index = _ref2.index,
      key = _ref2.key,
      style = _ref2.style;
    var _this$props7 = this.props,
      viewItemRenderer = _this$props7.viewItemRenderer,
      editItemRenderer = _this$props7.editItemRenderer,
      isNodeDisabled = _this$props7.isNodeDisabled,
      isNodeSelectable = _this$props7.isNodeSelectable,
      onContextMenu = _this$props7.onContextMenu,
      valueKey = _this$props7.valueKey,
      expandNodeFailureText = _this$props7.expandNodeFailureText,
      retryButtonText = _this$props7.retryButtonText,
      highlightSelected = _this$props7.highlightSelected,
      matchAlloyStyle = _this$props7.matchAlloyStyle,
      allowReselectNodes = _this$props7.allowReselectNodes,
      showDisabledSelection = _this$props7.showDisabledSelection,
      getNodeStyle = _this$props7.getNodeStyle,
      fixed = _this$props7.fixed,
      T = _this$props7.T;
    var _this$state3 = this.state,
      flatNodes = _this$state3.flatNodes,
      selectedKeys = _this$state3.selectedKeys,
      expandedKeys = _this$state3.expandedKeys,
      isMultiple = _this$state3.isMultiple;
    var node = flatNodes[index];
    // Node status
    var selected = selectedKeys.includes(node[valueKey]);
    var disabled = TreeHelper.isDisabled(node, isNodeDisabled);
    return /*#__PURE__*/React.createElement(TreeNode, {
      "data-testid": "node-label",
      key: node[valueKey] + "-" + key,
      style: _objectSpread(_objectSpread(_objectSpread({}, style), getNodeStyle({
        node: node,
        selected: selected,
        disabled: disabled
      })), {}, {
        width: fixed ? 'unset' : '100%',
        paddingLeft: node[TreeHelper.NODE_KEYS.NODE_LEVEL_KEY] * 28 + 'px'
      }),
      treeListRef: this.treeListRef,
      node: node,
      highlight: highlightSelected && !isMultiple,
      multiple: isMultiple,
      height: style.height,
      expandable: this.isNodeExpandable(node),
      expanded: expandedKeys.includes(node[valueKey]),
      selectable: isNodeSelectable(node),
      selected: selected,
      disabled: disabled,
      isActionNode: TreeHelper.isActionNode(node),
      expandNodeFailureText: expandNodeFailureText,
      retryButtonText: retryButtonText || T.translate('retryButtonText'),
      viewItemRenderer: viewItemRenderer,
      editItemRenderer: editItemRenderer,
      onReload: this.handleLoadNode,
      onToggle: this.handleToggleNode,
      onSelect: this.handleSelectNode,
      onContextMenu: onContextMenu,
      matchAlloyStyle: matchAlloyStyle,
      allowReselectNodes: allowReselectNodes,
      showDisabledSelection: showDisabledSelection
    });
  };
  _proto.renderTree = function renderTree(width, height) {
    var _this4 = this;
    var flatNodes = this.state.flatNodes;
    var _this$props8 = this.props,
      className = _this$props8.className,
      onScroll = _this$props8.onScroll,
      scrollToAlignment = _this$props8.scrollToAlignment,
      scrollTop = _this$props8.scrollTop,
      fixed = _this$props8.fixed;
    // Calculate the flat nodes whenever the state changed.
    return /*#__PURE__*/React.createElement(StyledList, {
      "aria-label": "tree-list",
      ref: function ref(node) {
        return _this4.treeListRef = node;
      },
      className: className,
      rowRenderer: this.rowRenderer,
      overscanRowCount: 5,
      width: width,
      height: height,
      rowHeight: this.rowHeight,
      rowCount: flatNodes.length,
      items: flatNodes,
      onScroll: onScroll,
      scrollToAlignment: scrollToAlignment,
      scrollTop: scrollTop,
      containerStyle: fixed && {
        overflow: 'unset'
      },
      style: fixed && {
        overflowX: 'auto'
      }
    });
  };
  _proto.render = function render() {
    var _this5 = this;
    var _this$props9 = this.props,
      nodes = _this$props9.nodes,
      emptyResultText = _this$props9.emptyResultText;
    if (nodes.length === 0) {
      return /*#__PURE__*/React.createElement(EmptyState, {
        gray: true,
        illustration: "sheets",
        title: emptyResultText || this.props.T.translate('emptyResult')
      });
    }
    return /*#__PURE__*/React.createElement(AutoSizer, null, function (_ref3) {
      var width = _ref3.width,
        height = _ref3.height;
      return _this5.renderTree(width, height);
    });
  };
  return VirtualizedTree;
}(React.Component);
VirtualizedTree.NODE_KEYS = TreeHelper.NODE_KEYS;
VirtualizedTree.TreeNode = TreeNode;
VirtualizedTree.propTypes = {
  /**
   * Class name for the component
   */
  className: PropTypes.string,
  /**
   * If the tree is multiple selectable
   */
  multiple: PropTypes.bool,
  /**
   * Use fixed mode to support horizontal scroll
   */
  fixed: PropTypes.bool,
  /**
   * Whether highligh selected item under single selection mode (multiple is false)
   */
  highlightSelected: PropTypes.bool,
  /**
   * Whether to allow reselection of already selected nodes
   */
  allowReselectNodes: PropTypes.bool,
  /**
   * Whether to show disabled selection under multiple mode
   */
  showDisabledSelection: PropTypes.bool,
  /**
   * Whether to enable select multi nodes while selecting by holding shift key.
   * Only allow to select nodes under same hierarchy level. Default is true.
   */
  enableShiftSelection: PropTypes.bool,
  /**
   * Whether to allow select nodes under same hierarchy level but with different parent node.
   * Only works when enableShiftSelection is true. Default is false.
   */
  enableCrossParentSelection: PropTypes.bool,
  /**
   * Default selected nodes
   */
  defaultSelectedKeys: PropTypes.array,
  /**
   * Default expand nodes
   */
  defaultExpandedKeys: PropTypes.array,
  /**
   * [Controlled] props to control if need to expand nodes
   */
  expandedKeys: PropTypes.array,
  /**
   * [Controlled] props to control if need to select nodes
   */
  selectedKeys: PropTypes.array,
  /**
   * [Controlled] props to control if need to align the specific node to fixed position when scrolling
   */
  scrollToAlignment: PropTypes.oneOf(['auto', 'center', 'start', 'end']),
  /**
   * The Vertical offset in pixels of the Virtualized List
   */
  scrollTop: PropTypes.number,
  /**
   * The text to show when loading sub nodes failure
   */
  retryButtonText: PropTypes.node,
  /**
   * The text to show when no valid nodes
   */
  emptyResultText: PropTypes.node,
  /**
   * Array of tree nodes
   */
  nodes: PropTypes.array,
  /**
   * Node value key or identifier key (unique key)
   */
  valueKey: PropTypes.string,
  /**
   * The sub nodes key.
   */
  childrenKey: PropTypes.string,
  /**
   * Failure text displayed when expand node failed
   */
  expandNodeFailureText: PropTypes.node,
  /**
   * A callback to check if node is leaf
   */
  isNodeExpandable: PropTypes.func,
  /**
   * A callback to check if node is selectable
   */
  isNodeDisabled: PropTypes.func,
  /**
   * A callback to check if node can be selected.
   * Like only select document at document folder picker.
   */
  isNodeSelectable: PropTypes.func,
  /**
   * A callback to render node display content, with the shape of "({ node, treeListRef }) => *"
   */
  viewItemRenderer: PropTypes.func.isRequired,
  /**
   * A callback to render editing node content, with the shape of "({ node, treeListRef }) => *"
   */
  editItemRenderer: PropTypes.func,
  /**
   * A callback function for the tree node click event
   * The handler is of the shape of "(nodes) => *"
   */
  onSelectNodesChange: PropTypes.func,
  /**
   * A callback function when list get scrolled
   * The handler is of the shape of "(event) => *"
   */
  onScroll: PropTypes.func,
  /**
   * A callback function for expand a tree node,
   * The handler is of the shape of "(node) => *"
   */
  onExpandNode: PropTypes.func,
  /**
   * A callback function for un-expand a tree node
   * The handler is of the shape of "(node) => *"
   */
  onUnexpandNode: PropTypes.func,
  /**
   * A callback function for the tree node context menu event
   * The handler is of the shape of "({node, event}) => *"
   */
  onContextMenu: PropTypes.func,
  /**
   * A callback function when got duplicated node by node `valueKey`
   * The handler is of the shape of "({ keys, nodes }) => *"
   */
  onDuplicatedKeys: PropTypes.func,
  /**
   * Whether match the styling to Alloy's style
   */
  matchAlloyStyle: PropTypes.bool,
  /**
   * The height in pixels of each Node.
   * Either a fixed value or a function of the shape "({ index, node }) => number"
   */
  rowHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  /**
   * A callback to customize tree node styles.
   * The callback is of the shape of "({ node, selected, disabled }) => Styled object"
   */
  getNodeStyle: PropTypes.func,
  /**
   * The translator injected by HOC
   */
  T: PropTypes.object
};
VirtualizedTree.defaultProps = {
  valueKey: 'id',
  childrenKey: 'children',
  nodes: [],
  multiple: false,
  highlightSelected: false,
  matchAlloyStyle: false,
  allowReselectNodes: false,
  showDisabledSelection: false,
  enableShiftSelection: false,
  enableCrossParentSelection: false,
  rowHeight: 35,
  isNodeDisabled: function isNodeDisabled() {
    return false;
  },
  isNodeSelectable: function isNodeSelectable() {
    return true;
  },
  editItemRenderer: noop,
  onSelectNodesChange: noop,
  onContextMenu: noop,
  onExpandNode: noop,
  onScroll: noop,
  onDuplicatedKeys: noop,
  getNodeStyle: noop,
  scrollToAlignment: 'center'
};
export default withT(VirtualizedTree, locales);
//# sourceMappingURL=VirtualizedTree.js.map